import {baseAxios} from '../helper/axiosHelper';

export const groupService = {
    getGroups,
    newGroup,
    getGroupMember,
    removeGroupMember,
    saveGroup,
    deleteGroup,
    getPossibleMember,
    updateGroupMember
};

function getGroups() {

    return baseAxios.get('group/groups')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getPossibleMember() {

    return baseAxios.get('group/possiblemember')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function newGroup(data) {

    return baseAxios.post('group/group',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteGroup(data) {

    return baseAxios.delete('group/group',{params:{id:data}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function saveGroup(data) {

    return baseAxios.put('group/group',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function updateGroupMember(data) {

    return baseAxios.put('group/groupmember',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getGroupMember(data){
    
    return baseAxios.get('group/groupmember',{params:{group_fk:data}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });    
}

function removeGroupMember(data){
    
    return baseAxios.delete('group/groupmember',{params:{id:data}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });    
}